<template>
    <admin-layout>
        <template #header>
            <h2 class="h4 font-weight-bold">
                Dashboard
            </h2>
        </template>

        <welcome />
    </admin-layout>
</template>

<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import Welcome from '@/Jetstream/Welcome'

    export default {
        components: {
            AdminLayout,
            Welcome,
        },
    }
</script>
